
import * as L from 'leaflet';
//import * as Cesium from 'cesium'; // to be restored when 3d view is available
//declare var Cesium: any;
import 'leaflet/dist/leaflet.css';
import './style.css'

import * as utils from '../../../utils';
import { discreteColorscale } from '../../colorscale';
import { makeLegendFromRanges } from '../../../modules/maps'

import { ContourData, ScatData } from '../../../types/data';

import { Aeroval } from '../../../types/global';
interface ExtendedGlobals extends Aeroval {
    mapTypes: string[];
    mapType: any;
    bordersColor: 'light' | 'dark';
    bordersColors: ExtendedGlobals['bordersColor'][];
    layersOpacity: number;
    stationsRadius: number;
    freshStart: boolean;
    prevSpeed: number;
    obs: string;
    recObs: string;
    date: number;
    previousDate: number;
    update: string;
    /*some data*/
    map1: any;
    region1: any;
    timeArray: number[];
    stations1: any;
    map2: any;
    region2: any;
    stations2: any;
    /**/
    viewer: any;
    scene: any;
    /**/
    geojsonLayer: any;
    legend: any;
    coos: any;
    loading: boolean;
    /*dynamic keys*/
    [key: string]: any;
}
declare var aeroval: ExtendedGlobals;

export function makeMap(mapDiv: 'mod1' | 'mod2', callback: (event: any) => void): void {

    // reset map element
    const divElement = document.getElementById(mapDiv);
    if (divElement) divElement.innerHTML = '';

    // set up initial view
    const center: L.LatLngTuple = aeroval.cfg.webdisp_opts.map_zoom == 'Europe' ? [55, 10] : [30, 0];
    var zoom = aeroval.cfg.webdisp_opts.map_zoom == 'Europe' ? 3 : 2;
    if (aeroval.isMobile) {
        zoom -= 1;
    }

    const myMap = L.map(mapDiv, {
        center,
        zoom,
        minZoom: 1,
        markerZoomAnimation: false,
        worldCopyJump: true,
        crs: L.CRS.EPSG3857,
        maxBounds: [
            [-90, -180.0],
            [90, 180.0],
        ],
        zoomControl: false,
        attributionControl: false,
        preferCanvas: true
    });

    const mapContainer = myMap.getContainer();
    mapContainer.style.cursor = 'grab';
    myMap.on('mousedown', () => {
        mapContainer.style.cursor = 'grabbing';
    });
    myMap.on('mouseup', () => {
        mapContainer.style.cursor = 'grab';
    });
    myMap.on('mouseout', () => {
        mapContainer.style.cursor = 'grab';
    });

    //set different panes to manage the zIndex
    myMap.createPane('background');
    myMap.createPane('data');
    myMap.createPane('grid');
    myMap.createPane('countries');
    myMap.createPane('region');

    (myMap.getPane('background') as HTMLElement).style.zIndex = '1';
    (myMap.getPane('data') as HTMLElement).style.zIndex = '2';
    (myMap.getPane('grid') as HTMLElement).style.zIndex = '3';
    (myMap.getPane('countries') as HTMLElement).style.zIndex = '4';
    (myMap.getPane('region') as HTMLElement).style.zIndex = '5';

    L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
        attribution: '&copy; <a href="https://openstreetmap.org/copyright">OpenStreetMap</a> contributors',
        noWrap: true,
        pane: 'background',
    }).addTo(myMap);

    // add countries border
    const filename = '../../geography/admin_0_countries/ne_110m_admin_0_countries.geojson';
    const geojsonLayer = L.geoJSON(undefined, {
        interactive: false,
        weight: 1,
        fillOpacity: 0,
        color: aeroval.bordersColor === 'dark' ? '#404040' : '#ffffff',
        opacity: 0.5,
        pane: 'countries',
    } as any);
    aeroval[`${mapDiv}-countries`] = geojsonLayer.addTo(myMap);
    aeroval.geojsonLayer = geojsonLayer;
    void loadGeoJsonIntoLayer(filename, geojsonLayer);

    //add click event
    myMap.on('click', onMapClick);

    if (mapDiv == 'mod1') {
        aeroval.map1 = myMap;
    } else if (mapDiv == 'mod2') {
        aeroval.map2 = myMap;
        // move map
        aeroval.map1.on('zoomlevelschange move', function () {
            const center = aeroval.map1.getCenter();
            const zoom = aeroval.map1.getZoom();
            myMap.setView(center, zoom);
        });
    }

    //responsive
    myMap.invalidateSize();


    //click on map
    function onMapClick() {
        // remove station data from time series
        const chartTS = utils.getChartById('map-ts');
        if (chartTS && !aeroval.isTSRegional) {
            const data = aeroval.data.ts
            if (!data) return;
            callback(data);
        }
    }
}

async function loadGeoJsonIntoLayer(filename: string, layer: L.GeoJSON): Promise<void> {
    try {
        const response = await fetch(filename);
        if (!response.ok) {
            throw new Error(`Failed to fetch ${filename}: ${response.status}`);
        }
        const data = await response.json();
        layer.addData(data);
    } catch (error) {
        console.error('Failed to load GeoJSON layer:', error);
    }
}

export function cleanMap(div: 'mod1' | 'mod2', keepObs: boolean = false) {
    const myMap = div === 'mod1' ? aeroval.map1 : aeroval.map2;
    if (!myMap) return;

    //delete aeroval.map1._panes.overlayPane
    myMap.eachLayer(function (layer: any) {
        if (layer.options.pane.includes(div) || (layer.options.pane.startsWith('obs-') && keepObs !== true)) {
            myMap.removeLayer(layer);
            delete myMap._panes[layer.options.pane];
            delete myMap._paneRenderers[layer.options.pane];
        }
    });
}

export function plotOverlay(url: string, map: L.Map, pane: string) {
    const altText = url;

    // Ensure model boundaries are valid
    if (!aeroval.cfg.modelmaps_opts.boundaries) {
        console.error("Missing model boundaries configuration.");
        return;
    }

    const { north, south, east, west } = aeroval.cfg.modelmaps_opts.boundaries;
    const southWest = L.latLng(south, west);
    const northEast = L.latLng(north, east);
    const latLngBounds = L.latLngBounds(southWest, northEast);

    var img = new Image();
    img.crossOrigin = 'Anonymous'; // Set cross-origin before setting the src
    img.src = url; // Set the image source

    img.onload = function () {
        // Initialize canvas
        var canvas = document.createElement('canvas');
        canvas.width = img.width;
        canvas.height = img.height;
        var ctx = canvas.getContext('2d');
        if (!ctx) {
            console.error("Failed to get canvas context.");
            return;
        }

        // Draw the image onto the canvas
        ctx.drawImage(img, 0, 0);

        // Get the image data
        const imageData = ctx.getImageData(0, 0, img.width, img.height);
        const data = imageData.data;

        // Apply the custom colormap
        for (var i = 0; i < data.length; i += 4) {
            var intensity = data[i]; // Assuming grayscale image (R channel)
            var color = colorFromSRGB(intensity); // Get color from colormap function
            if (!color) break
            data[i] = color.r;     // R
            data[i + 1] = color.g; // G
            data[i + 2] = color.b; // B
            // data[i + 3] remains unchanged (alpha channel)
        }

        // Put the modified image data back on the canvas
        ctx.putImageData(imageData, 0, 0);

        // Convert canvas to data URL and create ImageOverlay
        var recoloredUrl = canvas.toDataURL();

        L.imageOverlay(recoloredUrl, latLngBounds, {
            opacity: aeroval.layersOpacity ?? 1.0, // Default to full opacity if not set
            alt: altText,
            interactive: false,
            pane: pane
        }).addTo(map);
    };

    img.onerror = function () {
        console.error("Failed to load image:", url);
    };
}


function colorFromSRGB(rgb: number) {
    const value = Math.min(...aeroval.legend.levels) + (rgb / 255) * (Math.max(...aeroval.legend.levels) - Math.min(...aeroval.legend.levels))
    const hexColor = discreteColorscale(value, aeroval.legend.levels, aeroval.parameter.dir, aeroval.statistic.dir, aeroval.colorMapType);
    return utils.hexToRgb(hexColor)
}


export function plotFeatures(data: ContourData, map: any, pane: string) {
    const layerGroup = L.featureGroup().addTo(map);
    const commonStyle = {
        interactive: false,
        weight: 1,
        opacity: aeroval.layersOpacity,
        fillOpacity: aeroval.layersOpacity,
        renderer: L.canvas({ pane: pane })
    };
    data?.features.forEach((feature: any) => {
        const valueRange = feature.properties.title
        const value = valueRangeToValue(valueRange)
        const fillColor = pixelColor(value);
        const featureStyle = { ...commonStyle, color: fillColor };
        const geoJsonLayer = L.geoJSON(feature as any, { style: () => featureStyle });
        layerGroup.addLayer(geoJsonLayer);
    });
}


function valueRangeToValue(valueRange: string): number {
    if (valueRange.startsWith('>')) {
        return Number(valueRange.split('>')[1])
    } else {
        return Number(valueRange.split('-')[0])
    }
}


export function plotStations(data: ScatData, callback: (event: any) => void): void {

    const time = aeroval.timeArray
    if (!time) return;

    // make sure we have a legend
    if (!aeroval.legend || aeroval.mapType === 'overlay') {
        aeroval.legend = makeLegendFromRanges()
    }

    for (var model of ['model1', 'model2']) {

        if (aeroval[model]?.dir === 'None') continue;

        const div = model == 'model1' ? 'mod1' : 'mod2';
        const myMap = div === 'mod1' ? aeroval.map1 : aeroval.map2;
        const color = aeroval.bordersColor === 'light' ? colorCountry('dark') : colorCountry('light');
        const keyTime = aeroval.cfg.time_cfg.periods[0] + '-all';
        const opacity = 1;
        const fillOpacity = 1;

        const group = [] as any;

        for (const t of time) {
            //create pane and set zIndex
            const pane = `obs-${div}-${t}`;
            if (myMap.getPane(pane)) {
                delete myMap._paneRenderers[pane];
            } else {
                myMap.createPane(pane);
                myMap.getPane(pane).style.zIndex = 100;
            }

            const markers = [];
            for (let key in data) {
                //get index of scat corresponding to time
                const iTime = data[key][keyTime]['date'].indexOf(t);
                //if match time, opacity else 0
                if (iTime != -1) {
                    const value = data[key][keyTime]['obs'][iTime];
                    const fillColor = pixelColor(value);
                    const lat = data[key].latitude;
                    const lon = data[key].longitude;

                    const options = {
                        pane: pane,
                        name: key,
                        radius: aeroval.stationsRadius,
                        color,
                        fillColor,
                        stroke: true,
                        weight: 1,
                        fillOpacity,
                        opacity,
                    };
                    if (value != null) {
                        markers.push(
                            L.circleMarker([lat, lon], options).on('click', function (event: any) {
                                callback(event);
                            })
                        );
                    }
                }
            }

            if (!myMap.layers) {
                myMap.layers = {}
            }
            myMap.layers[pane] = L.layerGroup(markers).addTo(myMap);
            group.push(myMap.layers[pane]);

            // hide other time
            if (t !== aeroval.date) {
                myMap.getPane(pane).classList.add('hide');
            }
        }

        if (div == 'mod1') {
            aeroval.stations1 = group;
        } else if (div == 'mod2') {
            aeroval.stations2 = group;
        }
    }

    document.body.style.cursor = 'default';
}



function pixelColor(value: number): string | undefined {
    //returns color of pixel according to colorscale of polygons
    if (aeroval.legend) {
        const nearest = indexOfClosest(aeroval.legend.levels, value);
        return aeroval.legend.colors[nearest];
    } else {
        return undefined;
    }
}

function indexOfClosest(nums: number[], target: number): number {
    let closest = Number.MAX_SAFE_INTEGER;
    let index = -1;

    for (let i = 0; i < nums.length; i++) {
        const dist = Math.abs(target - nums[i]);
        if (dist < closest) {
            closest = dist;
            index = i;
            // Early exit if the exact match is found
            if (dist === 0) break;
        }
    }
    return index;
}


export function plotRegion() {
    if (aeroval.region1) {
        aeroval.region1.eachLayer(function (layer: any) {
            aeroval.region1.removeLayer(layer);
        });
    }

    if (!aeroval.coos) return;
    const mapRegion = L.featureGroup();
    const minLat = aeroval.coos.min.lat;
    const maxLat = aeroval.coos.max.lat;
    const minLon = aeroval.coos.min.lon;
    const maxLon = aeroval.coos.max.lon;

    // if the polygon does not cross the map
    if (minLon < maxLon) {
        var polygonPoints = [
            [minLat, minLon],
            [maxLat, minLon],
            [maxLat, maxLon],
            [minLat, maxLon],
        ];
        mapRegion.addLayer(
            L.polygon(polygonPoints, {
                fillOpacity: 0,
                color: 'gray',
                pane: 'region',
            })
        );
    } else {
        var polygonPointsRight = [
            [minLat, minLon],
            [maxLat, minLon],
            [maxLat, 180],
            [minLat, 180],
        ];
        var polygonPointsLeft = [
            [minLat, -180],
            [maxLat, -180],
            [maxLat, maxLon],
            [minLat, maxLon],
        ];
        mapRegion
            .addLayer(
                L.polygon(polygonPointsRight, {
                    fillOpacity: 0,
                    color: 'gray',
                    pane: 'region',
                })
            )
            .addLayer(
                L.polygon(polygonPointsLeft, {
                    fillOpacity: 0,
                    color: 'gray',
                    pane: 'region',
                })
            );
    }

    aeroval.map1.addLayer(mapRegion);
    aeroval.region1 = mapRegion;

    //go to this region
    //aeroval.map1.panTo(new L.LatLng(.5*(minLat+maxLat), .5*(minLon+maxLon)));
}

function colorCountry(color: 'light' | 'dark' = aeroval.bordersColor !== undefined ? aeroval.bordersColor : 'dark') {
    const colors = {
        dark: '#404040',
        light: '#ffffff',
    };
    return colors[color];
}

